import { getOccupancyText } from 'components/Recommendations/utils/getOccupancyText'
import { OfferPageState } from 'contexts/OfferPage/offerPageStateReducer'
import { generateRoomOccupants } from 'lib/offer/occupancyUtils'
import { createSelector } from 'reselect'

export const getDatesOccupancyLabel = createSelector(
  (offerPageState: OfferPageState) => offerPageState.rooms,
  (offerPageState: OfferPageState) => offerPageState.checkInDate,
  (offerPageState: OfferPageState) => offerPageState.duration,
  (rooms, checkIn, duration) => {
    if (!checkIn) return

    const roomOccupants = rooms || [generateRoomOccupants()]
    const occupancyLabel = getOccupancyText(roomOccupants, 'room')

    const checkOut = checkIn.clone().add(duration, 'days')
    const dateLabel = `${checkIn.format('DD')} - ${checkOut.format('DD MMM YYYY')}`

    return `${dateLabel}, ${occupancyLabel}`
  },
)
